import React, { Fragment, useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { useLocation } from 'react-router-dom';
import Masthead from '../components/Masthead/Masthead';
import TabControl from '../components/TabControl/TabControl';
import MobileApp from '../components/MobileApp/MobileApp';
import Disclosure from '../components/Disclosure/Disclosure';
import Footer from '../components/Footer/Footer';
import useAxios from '../utils/hooks/useAxios';
import { lobSourceName, targetLOB, lobDemoSplit, defaultMetaDescription} from '../utils/LobLogicModule';
import { Error, IsPending } from '../utils/SiteTools';

const Category = () => {
  /* get the source name and cat split from the lob logic module. */
  const sourceName = lobSourceName;
  const catSplit = targetLOB;
  const demoSplit = lobDemoSplit;
  const categoryName = useLocation().pathname.split('/')[catSplit];
  const { data: categoryContent, isPending, error } = useAxios(`${process.env.REACT_APP_GCDEV_API_CATEGORY_DETAIL}${categoryName}${sourceName}`);
  const getCategory = window.location.href;

  var match = getCategory.replace(/(.*\/)*/,"");

  const STATE_KEY = "demoCatName";

  sessionStorage.setItem(STATE_KEY, match.split('?')[0]);

  const [demoCatName] = useState(
    parseInt(sessionStorage.getItem(STATE_KEY))
  );

  useEffect(() => {
    sessionStorage.setItem(STATE_KEY, demoCatName);
	}, [demoCatName]);

  return (
    <Fragment>
      { isPending && <IsPending /> }
      {(error || categoryContent?.error) && <Error errorMessage={error || categoryContent.error.message} /> }
    
      { (categoryContent && !categoryContent.error) && <main className="category" data-pageid={categoryName}>
        <Helmet>
          <html lang={categoryContent.lang + '-US'} />
          <meta name="description" content={`${categoryContent.metadata ? categoryContent.metadata : defaultMetaDescription}`}/>
          </Helmet>
        <Masthead content={categoryContent} />
        <TabControl categoryId={categoryName} />
        {categoryName !== 'merchantservices'? <MobileApp /> : ''}
        <Disclosure disclosures={categoryContent.disclosures}  />
        <Footer footerMap={(demoSplit === '/ml' || demoSplit === '/privatebank' ? `MAP5432664, ` : ``) + categoryContent.mapNumber} />
      </main> }
    </Fragment>
  )
}

export default Category;